<div class="pricing-wrapper">
  <app-navbar [hide_menu]="coreService.isLoggedIn()"
    [home_address]="session_info?.last_routes.new_home || '/'"></app-navbar>
  <div class="container">
    <div class="pricing-header">
      <div class="row">
        <div class="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
          <h1 class="lg mt-0">Pricing Plans</h1>
          <p class="lg mt-3">Choose one of our affordable plans to get started.</p>
        </div>
        <div class="col-lg-4 text-center text-lg-end">
          <div class="switches-container mx-auto ms-lg-auto me-lg-0">
            <input type="radio" [checked]="durations.yearly === duration" id="switchYearly" name="switchPlan"
              (change)="duration = durations.yearly; interpretPricing()">
            <input type="radio" [checked]="durations.monthly === duration" id="switchMonthly" name="switchPlan"
              (change)="duration = durations.monthly; interpretPricing()" checked="checked">
            <label for="switchYearly">Yearly</label>
            <label for="switchMonthly">Monthly</label>
            <div class="switch-wrapper">
              <div class="switch">
                <div>Yearly</div>
                <div>Monthly</div>
              </div>
            </div>
          </div>
          <br>
          <b class="mt-5">Save at least <span class="text-success">12%</span> with yearly subscriptions</b>
        </div>
      </div>
    </div>

    <div class="packages-wrapper mt-5">
      <div class="row g-3 justify-content-center">
        <ng-container *ngIf="!local_prices?.length; else pricingNotLoading">
          <app-loading></app-loading>
        </ng-container>
        <ng-template #pricingNotLoading>

          <div class="col-lg-3 col-md-6 col-sm-6" *ngFor="let lp of local_prices">
            <div class="plan" [class.pro]="lp.is_popular">
              <ng-container *ngIf="lp.is_popular">
                <div class="ribbon">
                  <svg height="30" width="140">
                    <polygon class="ribbon__bends" points="0 20,10 30,20 20"
                      style="fill:currentColor;stroke:#DD3F3F;stroke-width:0" />
                    <polygon class="ribbon__bends" points="120 20,130 30,140 20"
                      style="fill:currentColor;stroke:#DD3F3F;stroke-width:0" />
                    <polygon class="ribbon__body" points="120 0,140 20,0 20, 20 0" style="fill:currentColor;" />
                  </svg>
                  <span class="ribbon__text">most popular</span>
                </div>
              </ng-container>
              <b class="plan-name">{{lp.title}}</b>
              <ng-container *ngIf="lp.show_price; else hidePrice">
                <h2 class="price"><sup>{{lp.currency}}</sup>{{lp.unit_price}}<span class="month">/
                    month</span></h2>
              </ng-container>
              <ng-template #hidePrice>
                <h2 class="contact">Contact Us</h2>
              </ng-template>
              <p class="mt-2">Billed {{lp.billed}}</p>

              <div class="plan-details-wrapper">
                <div class="plan-details" *ngFor="let highlight of lp.highlights">
                  <div class="amount" [innerHtml]="highlight.v"></div>
                  <div class="amount-title">{{highlight.k}}</div>
                </div>
              </div>

              <ng-container
                *ngIf="lp.rank === user_details?.current_organization_details?.subscription_details?.subscription?.rank; else notCurrent">
                <button class="btn mt-3 btn-lg btn-block cursor-default">
                  <span class="text-success">CURRENT</span>
                </button>
              </ng-container>
              <ng-template #notCurrent>
                <button class="btn btn-lg btn-block mt-3" (click)="getStarted(lp)"
                  [ngClass]="{'btn-outline-primary': !lp.is_popular, 'btn-light': lp.is_popular}">
                  <app-inline-loader bg_color="primary" *ngIf="busy_ids.indexOf(lp.id) > -1">
                  </app-inline-loader>
                  <span *ngIf="busy_ids.indexOf(lp.id) === -1">
                    <ng-container *ngIf="coreService.isLoggedIn(); else notLoggedIn">
                      <span
                        *ngIf="user_details.current_organization_details.subscription_details.future_subscription_product_id === lp.id; else notNext">Next
                        plan</span>
                      <ng-template #notNext>
                        <span
                          *ngIf="lp.rank < user_details.current_organization_details.subscription_details.subscription.rank">Downgrade</span>
                        <span
                          *ngIf="lp.rank > user_details.current_organization_details.subscription_details.subscription.rank">Upgrade</span>
                      </ng-template>
                    </ng-container>
                    <ng-template #notLoggedIn>Get Started</ng-template>
                  </span>
                </button>
              </ng-template>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <app-core-faqs-landing-page [category]="faq_category"></app-core-faqs-landing-page>

  </div>
</div>

<app-footer></app-footer>
<app-shared-bounce-modal *ngIf="!coreService.isLoggedIn()"></app-shared-bounce-modal>


<!-- DOWNGRADE PLAN MODAL -->
<div class="modal fade" id="downgradePlanModal" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-body text-center py-4">
        <div class="icon-bg mb-3">
          <i class="bi bi-credit-card-2-back"></i>
        </div>
        <b>Are you sure you want to downgrade your current plan?</b>
        <ng-container *ngIf="coreService.isLoggedIn()">
          <p class="mt-2 mb-4">You will be on
            <b>{{user_details.current_organization_details.subscription_details.subscription.title}}</b>
            until
            <b>{{functionService.datePimped(user_details.current_organization_details.subscription_details.end_date)}}</b>,
            your subscription will be downgraded afterwards.
          </p>
        </ng-container>
        <button class="btn btn-outline-secondary me-2" data-bs-dismiss="modal">Cancel</button>
        <button class="btn btn-secondary" (click)="downgradeSubscription()">
          <app-inline-loader version="v2" [hidden]="!downgrading"></app-inline-loader>
          <span [hidden]="downgrading">Downgrade Plan</span>
        </button>
      </div>
    </div>
  </div>
</div>


<!-- CHECKOUT FORBIDDEN MODAL -->
<div class="modal fade" id="checkoutNotAllowed" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <app-action-denied-contact-support msg="Subscription switch is not permitted for your account.">
        </app-action-denied-contact-support>
        <div class="text-center pb-4">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal_element?.hide()">Ok, got it!</button>
        </div>
      </div>
    </div>
  </div>
</div>